var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRobotoV29Latin700(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "roboto-v29-latin-700_svg__Roboto",
    horizAdvX: 1191
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Roboto",
    unitsPerEm: 2048,
    panose1: "2 0 0 0 0 0 0 0 0 0",
    ascent: 1900,
    descent: -500,
    alphabetic: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 510
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    horizAdvX: 557,
    d: "M405 447H165l-34 1009h308L405 447zM285 289q73 0 117-43t45-110q0-66-44-109T285-16q-72 0-116 43t-45 109 44 109 117 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    horizAdvX: 657,
    d: "M266 1398l-40-411H64v549h202v-138zm325 0l-39-411H390v549h201v-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    horizAdvX: 1220,
    d: "M667 410H474L402 0H219l72 410H64v172h257l50 284H139v174h263l73 416h182l-73-416h194l73 416h183l-73-416h219V866H930l-50-284h224V410H850L778 0H595l72 410zM504 582h193l50 284H553l-49-284z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    horizAdvX: 1175,
    d: "M790 383q0 82-45 130t-155 90-188 81-135 93-88 124-32 169q0 169 108 277t287 126v214h160v-217q177-25 277-147t100-318H790q0 120-49 179t-133 60q-82 0-127-46t-45-129q0-76 44-122t163-94 197-90 130-96 81-122 28-160q0-170-106-276T681-16v-199H522v198Q317 5 205 128T92 457h289q0-119 56-182t163-64q88 0 139 46t51 126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    horizAdvX: 1512,
    d: "M95 1176q0 134 87 217t228 84q143 0 230-82t87-224v-72q0-135-87-217t-228-82q-142 0-229 82t-88 223v71zm192-77q0-60 34-96t91-37 89 37 33 99v74q0 60-33 97t-91 37q-55 0-89-36t-34-102v-73zm504-742q0 135 88 217t228 83q142 0 229-81t88-225v-72q0-134-86-216t-229-83q-144 0-231 83t-87 220v74zm192-78q0-55 36-94t90-39q122 0 122 135v76q0 60-34 96t-90 37-90-36-34-100v-75zM469 109l-141 76 711 1138 141-76L469 109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    horizAdvX: 1344,
    d: "M71 392q0 101 56 187t208 191q-65 87-102 163t-37 160q0 170 107 276t290 107q163 0 267-97t105-242q0-174-176-307l-112-81 251-292q59 116 59 256h246q0-284-131-460L1320 0H992l-75 86Q756-20 547-20 331-20 201 93T71 392zm490-180q104 0 197 58L471 602l-21-15q-89-76-89-179 0-87 55-141t145-55zm-106 885q0-75 88-189l77 51q59 38 81 74t23 86-37 87-95 37q-62 0-99-40t-38-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    horizAdvX: 331,
    d: "M275 1389l-29-404H63v551h212v-147z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    horizAdvX: 719,
    d: "M124 592q0 229 61 436t180 366 258 222l56-156q-146-108-228-334t-82-528v-31q0-303 81-530t229-339l-56-153q-136 61-253 215T190 117t-66 422v53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    horizAdvX: 722,
    d: "M609 569q0-226-65-435T357-235 96-455L40-302Q182-195 264 28t85 513v53q0 299-81 527T40 1463l56 153q136-59 256-214t187-361 70-427v-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    horizAdvX: 928,
    d: "M341 962l-314 89 59 181 311-125-20 349h196l-20-356 303 123 59-183-320-89 210-266-159-113-182 292-180-282-159 108 216 272z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    horizAdvX: 1118,
    d: "M694 815h361V554H694V146H419v408H57v261h362v391h275V815z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    horizAdvX: 500,
    d: "M186-365L35-286l36 65q67 122 69 243v224h244l-1-200q-1-111-56-224T186-365z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    horizAdvX: 794,
    d: "M673 507H110v233h563V507z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    horizAdvX: 595,
    d: "M126 142q0 69 46 112t117 43q71 0 117-43t47-112q0-68-46-110T289-11q-71 0-117 42t-46 111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    horizAdvX: 765,
    d: "M202-125H-13l536 1581h215L202-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    horizAdvX: 1175,
    d: "M1079 602q0-302-125-462T588-20q-238 0-364 157T95 587v268q0 305 126 463t365 158 364-156 129-450V602zM790 896q0 181-49 263t-155 83q-102 0-150-78t-52-246V564q0-178 48-264t156-87q106 0 153 83t49 254v346z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    horizAdvX: 1175,
    d: "M801 0H512v1114l-345-107v235l603 216h31V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    horizAdvX: 1175,
    d: "M1097 0H99v198l471 502q97 106 143 185t47 150q0 97-49 152t-140 56q-98 0-154-67t-57-178H70q0 133 63 243t180 172 263 63q225 0 349-108t125-305q0-108-56-220T802 582L471 233h626V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    horizAdvX: 1175,
    d: "M393 856h154q110 0 163 55t53 146q0 88-52 137t-145 49q-83 0-139-45t-56-119H82q0 114 61 204t172 142 244 51q231 0 362-110t131-305q0-100-61-184T831 748q123-44 183-132t61-208q0-194-141-311T559-20Q341-20 203 95T64 399h289q0-82 61-134t152-52q103 0 161 54t59 145q0 218-240 218H393v226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    horizAdvX: 1175,
    d: "M954 548h165V315H954V0H665v315H68L55 497l607 959h292V548zm-611 0h322v514l-19-33-303-481z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    horizAdvX: 1175,
    d: "M142 716l84 740h816v-241H463l-36-313q103 55 219 55 208 0 326-129t118-361q0-141-59-252T860 42 598-20q-132 0-245 53T175 184t-70 221h286q9-91 63-141t143-51q98 0 151 70t53 200q0 124-61 190t-173 66q-103 0-167-54l-28-26-230 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    horizAdvX: 1175,
    d: "M883 1471v-238h-28q-196-3-315-102T396 856q116 118 293 118 190 0 302-136t112-358q0-142-61-257T868 44 613-20q-230 0-371 160T100 567v104q0 237 89 418t257 281 389 101h48zM601 742q-70 0-127-36t-84-97v-88q0-145 57-226t160-82q93 0 150 73t58 191q0 119-58 192t-156 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    horizAdvX: 1175,
    d: "M1089 1294L526 0H221l564 1222H61v234h1028v-162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    horizAdvX: 1175,
    d: "M1048 1069q0-106-53-188T849 750q106-51 168-140t62-211q0-194-132-306T588-20 228 93 95 399q0 121 62 211t167 140q-93 49-145 131t-53 188q0 186 124 296t337 111q212 0 336-109t125-298zM789 420q0 95-55 152t-148 57q-92 0-147-56t-55-153q0-93 54-150t150-57q94 0 147 55t54 152zm-30 635q0 85-45 136t-127 52q-81 0-126-50t-45-138q0-87 45-140t127-53 126 53 45 140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    horizAdvX: 1175,
    d: "M775 582Q662 471 511 471q-193 0-309 132T86 961q0 143 62 262t175 186 252 67q144 0 256-72t174-207 63-309V781q0-364-181-572T374-13l-71-1v241l64 1q377 17 408 354zM582 692q70 0 120 36t77 87v119q0 147-56 228t-150 81q-87 0-143-79t-56-200q0-119 54-195t154-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    horizAdvX: 578,
    d: "M381 142q0 69 46 112t117 43q71 0 117-43t47-112q0-68-46-110T544-11q-71 0-117 42t-46 111zM125 961q0 69 46 112t117 43q71 0 117-43t47-112q0-68-46-110t-118-43q-71 0-117 42t-46 111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    horizAdvX: 537,
    d: "M108 961q0 69 46 112t117 43q71 0 117-43t47-112q0-68-46-110t-118-43q-71 0-117 42t-46 111zM208-365L57-286l36 65q67 122 69 243v224h244l-1-200q-1-111-56-224T208-365z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    horizAdvX: 1042,
    d: "M345 618l570-201V137L54 502v236l861 365V823L345 618z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    horizAdvX: 1172,
    d: "M1030 746H136v236h894V746zm0-433H136v236h894V313z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    horizAdvX: 1058,
    d: "M701 621L120 824v278l871-365V502L120 136v279l581 206z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    horizAdvX: 1019,
    d: "M347 447q0 140 34 223t124 163 121 131 30 107q0 169-156 169-74 0-118-45t-47-126H45q2 191 123 299t332 108q212 0 329-102t117-290q0-85-38-160T775 756l-81-77q-76-73-87-171l-4-61H347zm-29-307q0 67 45 110t117 44 116-43 46-111q0-66-44-109T480-12 363 31t-45 109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    horizAdvX: 1833,
    d: "M1749 536q-11-256-126-406T1312-21q-86 0-148 37t-95 106Q969-18 808-18q-146 0-226 123t-60 325q18 165 83 293t166 198 216 69q143 0 244-66l63-43-51-578q-10-79 17-121t88-42q92 0 154 107t68 282q17 349-140 536t-467 188q-193 0-344-98T381 877t-98-414Q267 109 425-84t473-194q83 0 174 18t157 50l38-154q-61-40-164-64t-209-25q-264 0-450 106T167-33 87 463q12 276 126 495t310 338 444 120q251 0 432-107t271-308 79-465zM744 430q-11-132 23-200t110-69q49 0 93 43t73 124l42 473q-39 13-80 13-115 0-178-98t-83-286z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    horizAdvX: 1378,
    d: "M952 300H426L326 0H7l542 1456h278L1372 0h-319L952 300zM507 543h364l-183 545-181-545z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    horizAdvX: 1307,
    d: "M130 0v1456h510q265 0 402-101t137-298q0-107-55-188T971 749q112-28 176-113t65-208q0-210-134-318T696 0H130zm300 634V241h257q106 0 165 50t60 140q0 200-207 203H430zm0 212h222q227 4 227 181 0 99-57 142t-182 44H430V846z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    horizAdvX: 1340,
    d: "M1273 485q-17-235-173-370T687-20q-280 0-440 188T86 686v89q0 210 74 370t211 245 320 86q252 0 406-135t178-379H975q-11 141-78 204t-206 64q-150 0-224-107t-77-334V679q0-236 71-345t226-109q139 0 207 63t79 197h300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    horizAdvX: 1331,
    d: "M130 0v1456h448q192 0 343-86t237-246 85-363v-67q0-203-83-361T924 88 581 0H130zm300 1213V241h145q176 0 269 115t95 329v77q0 222-92 336t-269 115H430z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    horizAdvX: 1152,
    d: "M1006 631H430V241h676V0H130v1456h974v-243H430V866h576V631z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    horizAdvX: 1122,
    d: "M1006 595H430V0H130v1456h948v-243H430V837h576V595z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    horizAdvX: 1395,
    d: "M1282 184q-81-97-229-150T725-20q-189 0-331 82T174 302 94 671v99q0 218 73 377t212 244 325 85q259 0 405-123t173-360H990q-20 125-88 183t-189 58q-153 0-233-115t-81-342v-93q0-229 87-346t255-117q169 0 241 72v251H709v221h573V184z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    horizAdvX: 1447,
    d: "M1315 0h-300v624H430V0H130v1456h300V866h585v590h300V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    horizAdvX: 597,
    d: "M449 0H149v1456h300V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    horizAdvX: 1144,
    d: "M717 1456h300V448q0-139-61-245T782 38 529-20Q298-20 169 97T40 430h302q0-107 45-158t142-51q86 0 137 59t51 168v1008z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    horizAdvX: 1300,
    d: "M586 584L430 416V0H130v1456h300V796l132 181 371 479h369L785 809 1317 0H960L586 584z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    horizAdvX: 1109,
    d: "M430 241h637V0H130v1456h300V241z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    horizAdvX: 1794,
    d: "M522 1456L896 400l372 1056h394V0h-301v398l30 687L998 0H792L400 1084l30-686V0H130v1456h392z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    horizAdvX: 1446,
    d: "M1314 0h-300L430 958V0H130v1456h300l585-960v960h299V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    horizAdvX: 1414,
    d: "M1326 695q0-215-76-377T1033 68 708-20q-181 0-323 87T165 315 86 687v72q0 215 77 378t219 251 324 88 323-87 219-251 78-378v-65zm-304 66q0 229-82 348t-234 119q-151 0-233-117t-83-345v-71q0-223 82-346t236-123q151 0 232 118t82 346v71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    horizAdvX: 1321,
    d: "M430 513V0H130v1456h568q164 0 288-60t192-170 67-252q0-214-146-337T693 513H430zm0 243h268q119 0 181 56t63 160q0 107-63 173t-174 68H430V756z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    horizAdvX: 1414,
    d: "M1324 695q0-204-66-354T1075 99l242-190-191-169L816-11q-53-9-110-9-181 0-323 87T163 315 84 687v72q0 215 77 378t219 251 324 88 323-87 219-251 78-378v-65zm-304 66q0 229-82 348t-234 119q-151 0-233-117t-83-345v-71q0-223 82-346t236-123q151 0 232 118t82 346v71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    horizAdvX: 1307,
    d: "M669 533H430V0H130v1456h541q258 0 398-115t140-325q0-149-64-248T949 609l315-595V0H942L669 533zM430 776h242q113 0 175 57t62 159q0 103-58 162t-180 59H430V776z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    horizAdvX: 1259,
    d: "M885 382q0 85-60 130t-216 96-247 100q-248 134-248 361 0 118 66 210t191 145 280 52q156 0 278-56t189-160 68-234H886q0 100-63 155t-177 56q-110 0-171-46t-61-123q0-71 71-119t211-90q256-77 373-191t117-284q0-189-143-296T658-20q-168 0-306 61T142 210 69 458h301q0-241 288-241 107 0 167 43t60 122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    horizAdvX: 1267,
    d: "M1226 1213H780V0H480v1213H40v243h1186v-243z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    horizAdvX: 1348,
    d: "M1232 1456V497q0-239-149-378T674-20q-255 0-405 135T116 486v970h300V495q0-143 68-208t190-66q253 0 257 266v969h301z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    horizAdvX: 1339,
    d: "M668 361l330 1095h334L825 0H512L7 1456h333L668 361z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    horizAdvX: 1791,
    d: "M1264 420l196 1036h299L1436 0h-302L897 974 660 0H358L35 1456h299L531 422l240 1034h254l239-1036z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    horizAdvX: 1301,
    d: "M651 954l273 502h345L845 734 1280 0H931L651 510 371 0H22l435 734-424 722h345l273-502z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    horizAdvX: 1266,
    d: "M632 800l303 656h328L785 528V0H480v528L2 1456h329l301-656z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    horizAdvX: 1241,
    d: "M448 241h734V0H73v176l720 1037H74v243h1092v-172L448 241z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    horizAdvX: 569,
    d: "M552 1471H410V-116h142v-223H120v2033h432v-223z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    horizAdvX: 864,
    d: "M0 1456h295L903-125H607L0 1456z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    horizAdvX: 569,
    d: "M13 1694h432V-339H13v223h143v1587H13v223z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    horizAdvX: 895,
    d: "M448 1186L274 729H44l299 727h210l299-727H623l-175 457z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    horizAdvX: 914,
    d: "M912-226H1V0h911v-226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    horizAdvX: 677,
    d: "M565 1226H328L52 1536h315l198-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    horizAdvX: 1098,
    d: "M738 0q-20 39-29 97Q604-20 436-20q-159 0-263 92T68 304q0 172 127 264t369 93h133v62q0 75-38 120t-122 45q-73 0-114-35t-42-96H92q0 94 58 174t164 125 238 46q200 0 317-100t118-283V250q1-154 43-233V0H738zM499 201q64 0 118 28t80 77v186H589q-217 0-231-150l-1-17q0-54 38-89t104-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    horizAdvX: 1153,
    d: "M1086 531q0-260-111-405T665-20q-176 0-281 135L371 0H111v1536h289V985q100 117 263 117 198 0 310-145t113-410v-16zm-289 21q0 164-52 239t-155 76q-138 0-190-113V327q53-114 192-114 140 0 184 138 21 66 21 201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    horizAdvX: 1068,
    d: "M561 213q80 0 130 44t52 117h271q-1-110-60-201T793 31 566-20q-232 0-366 147T66 535v19q0 250 133 399t365 149q203 0 325-115t125-308H743q-2 84-52 136t-132 53q-101 0-152-73t-52-239v-30q0-167 51-240t155-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    horizAdvX: 1154,
    d: "M66 549q0 253 113 403t311 150q158 0 261-118v552h290V0H780l-14 115Q658-20 488-20q-191 0-306 150T66 549zm289-21q0-152 53-233t154-81q134 0 189 113v427q-54 113-187 113-209 0-209-339z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    horizAdvX: 1107,
    d: "M609-20q-238 0-387 146T72 515v28q0 163 63 291t178 198 264 70q222 0 349-140t128-397V447H365q14-106 84-170t179-64q167 0 261 121l142-159Q966 83 855 32T609-20zm-33 888q-86 0-139-58t-69-166h402v23q-2 96-52 148t-142 53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    horizAdvX: 734,
    d: "M190 0v870H29v212h161v92q0 182 104 282t293 101q60 0 147-20l-3-224q-36 9-88 9-163 0-163-153v-87h215V870H480V0H190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    horizAdvX: 1169,
    d: "M69 549q0 249 118 401t320 152q178 0 277-122l12 102h262V36q0-142-64-247T812-371t-274-55q-119 0-232 47T135-256L263-80q108-121 262-121 115 0 179 61t64 175v58Q668-20 505-20q-195 0-315 152T69 537v12zm289-21q0-147 59-230t162-84q132 0 189 99v455q-58 99-187 99-104 0-163-85t-60-254z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    horizAdvX: 1146,
    d: "M393 964q115 138 289 138 352 0 357-409V0H750v685q0 93-40 137t-133 45q-127 0-184-98V0H104v1536h289V964z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    horizAdvX: 543,
    d: "M416 0H126v1082h290V0zM109 1362q0 65 43 107t119 42q74 0 118-42t44-107q0-66-44-108t-118-42-117 42-45 108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    horizAdvX: 532,
    d: "M417 1082V-59q0-179-95-278T48-437q-75 0-143 17v229q52-9 91-9 131 0 131 139v1143h290zm-313 280q0 65 43 107t119 42 118-42 44-107q0-66-44-108t-118-42-117 42-45 108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    horizAdvX: 1094,
    d: "M504 434L400 330V0H111v1536h289V685l56 72 277 325h347L689 631 1114 0H782L504 434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    horizAdvX: 543,
    d: "M416 0H126v1536h290V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    horizAdvX: 1773,
    d: "M382 1082l9-121q115 141 311 141 209 0 287-165 114 165 325 165 176 0 262-102t86-309V0h-290v690q0 92-36 134t-127 43q-130 0-180-124l1-743H741v689q0 94-37 136t-126 42q-123 0-178-102V0H111v1082h271z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    horizAdvX: 1147,
    d: "M377 1082l9-125q116 145 311 145 172 0 256-101t86-302V0H750v692q0 92-40 133t-133 42q-122 0-183-104V0H105v1082h272z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    horizAdvX: 1158,
    d: "M66 551q0 161 62 287t178 195 271 69q219 0 357-134t155-364l2-74q0-249-139-399T579-20 206 130 66 538v13zm289-21q0-154 58-235t166-82q105 0 164 80t59 258q0 151-59 234t-166 83q-106 0-164-82t-58-256z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    horizAdvX: 1153,
    d: "M1085 531q0-250-113-400T665-20Q501-20 400 94v-510H111v1498h268l10-106q105 126 274 126 200 0 311-148t111-408v-15zm-289 21q0 151-53 233t-156 82q-136 0-187-104V320q53-107 189-107 207 0 207 339z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    horizAdvX: 1157,
    d: "M66 551q0 255 113 403t312 148q174 0 277-133l19 113h254V-416H751V93Q651-20 489-20q-193 0-308 150T66 551zm289-21q0-155 54-236t154-81q133 0 188 106v447q-54 102-186 102-100 0-155-81t-55-257z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    horizAdvX: 747,
    d: "M719 811q-59 8-104 8-164 0-215-111V0H111v1082h273l8-129q87 149 241 149 48 0 90-13l-4-278z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    horizAdvX: 1053,
    d: "M697 299q0 53-52 83t-169 55Q90 518 90 765q0 144 119 240t313 97q206 0 329-97t124-252H686q0 62-40 102t-125 41q-73 0-113-33t-40-84q0-48 45-77t154-51 182-49q229-84 229-291 0-148-127-239T523-20q-136 0-241 48T116 161 56 344h274q4-77 57-118t142-41q83 0 125 31t43 83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    horizAdvX: 692,
    d: "M457 1348v-266h185V870H457V330q0-60 23-86t88-26q48 0 85 7V6q-85-26-175-26-304 0-310 307v583H10v212h158v266h289z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    horizAdvX: 1146,
    d: "M759 110Q652-20 463-20 289-20 198 80t-94 293v709h289V383q0-169 154-169 147 0 202 102v766h290V0H767l-8 110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    horizAdvX: 1035,
    d: "M516 353l201 729h302L654 0H378L13 1082h302l201-729z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    horizAdvX: 1505,
    d: "M1052 393l142 689h279L1197 0H955L750 681 545 0H304L28 1082h279l141-688 198 688h209l197-689z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    horizAdvX: 1042,
    d: "M523 759l182 323h309L706 552 1027 0H717L524 340 332 0H21l321 552-307 530h310l178-323z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    horizAdvX: 1028,
    d: "M515 409l200 673h310L590-168l-24-57q-97-212-320-212-63 0-128 19v219l44-1q82 0 122 25t64 83l34 89L3 1082h311l201-673z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    horizAdvX: 1042,
    d: "M443 233h529V0H74v176l509 672H89v234h867V911L443 233z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    horizAdvX: 676,
    d: "M586-360Q226-259 226 105v199q0 211-178 211v207q174 0 178 199v212q0 185 90 299t270 165l56-161q-76-28-115-97t-41-193V936q0-226-179-317 179-92 179-319V88q5-234 156-286l-56-162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    horizAdvX: 518,
    d: "M348-270H173v1726h175V-270z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    horizAdvX: 676,
    d: "M34-198q152 54 156 290v212q0 226 183 314-183 88-183 319v209q-4 233-156 290l56 161q179-50 269-163t91-298V921q4-199 178-199V515q-178 0-178-209V89q-8-350-360-449L34-198z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    horizAdvX: 1328,
    d: "M1221 793q0-186-93-302T888 375q-74 0-137 28T604 511t-153 80q-58 0-94-50t-36-128l-215 2q0 186 90 299t241 113q78 0 142-30t145-107 149-78q59 0 96 53t38 129l214-1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 510
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA1",
    horizAdvX: 578,
    d: "M170 639h241l33-1008H137l33 1008zm282 309q0-67-46-110t-116-43-116 43-46 110 44 110 118 43 117-43 45-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA2",
    horizAdvX: 1178,
    d: "M594 213q80 0 130 44t52 117h272q-2-145-98-250T698-11v-234H498v233Q311 18 205 162T99 532v22q0 218 105 363t294 177v224h200v-225q163-29 255-140t95-274H776q-2 86-52 137t-131 52q-102 0-153-74t-52-235v-33q0-168 51-240t155-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA3",
    horizAdvX: 1217,
    d: "M564 576l6-139q0-123-62-196h653V0H102v241h92q72 18 72 179l-5 156H99v236h154l-7 227q0 202 123 319t331 117q212 0 333-112t121-305H867q0 85-43 130t-125 45q-66 0-109-49t-44-145l9-227h309V576H564z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA4",
    horizAdvX: 1418,
    d: "M1073 107Q914-20 712-20q-203 0-361 126L222-26 81 118l135 137Q116 411 116 608q0 204 109 365L81 1120l141 144 142-145q155 115 348 115 194 0 349-117l144 148 142-145-148-151q107-159 107-361 0-193-98-349l139-141-142-145-132 134zM302 608q0-118 54-219t149-160 207-59q110 0 205 58t150 160 54 220q0 119-54 219T918 986t-206 58q-112 0-207-58T356 828t-54-220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA5",
    horizAdvX: 1098,
    d: "M550 892l224 564h313L765 742h218V567H695V452h288V278H695V0H395v278H89v174h306v115H89v175h244L10 1456h315l225-564z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA6",
    horizAdvX: 516,
    d: "M128-270v795h260v-795H128zm260 968H128v758h260V698z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA7",
    horizAdvX: 1287,
    d: "M1180 481q0-182-162-271 135-102 135-288 0-175-137-274T636-452q-257 0-400 107T92-35l289 1q0-89 64-136t191-48q112 0 170 37t58 101q0 65-64 106t-247 91-275 106-138 130-46 181q0 180 162 273-136 103-136 288 0 171 140 276t380 105q247 0 383-113t136-314H870q0 87-61 140t-169 54q-110 0-170-39t-60-107q0-73 55-110t241-86 282-104 145-131 47-185zM458 704q-75-42-75-141 0-69 41-106t166-78l222-67q82 47 82 140 0 62-45 101t-164 80l-227 71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA8",
    horizAdvX: 956,
    d: "M371 1365q0-53-39-89t-100-37q-62 0-100 37t-38 89 38 89 100 38 100-37 39-90zm210 0q0 54 40 90t99 37q59 0 98-37t40-90q0-52-38-89t-100-38-100 37-39 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xA9",
    horizAdvX: 1606,
    d: "M1117 596q0-152-87-233t-248-81-254 106-95 287v113q0 174 95 280t254 107q163 0 249-82t87-232H962q0 96-46 137t-134 42q-92 0-142-67t-52-181V669q0-117 51-184t143-68q89 0 134 40t45 139h156zm266 133q0 166-75 308t-212 228-300 86q-159 0-295-82t-215-226-78-314 77-314 214-227 297-84 297 85 214 229 76 311zM86 729q0 202 93 375t259 272 358 100 357-99 259-273 94-375q0-204-95-377T1152 79 796-20Q603-20 439 80T180 353 86 729z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAA",
    horizAdvX: 909,
    d: "M604 705q-10 27-17 68-77-82-201-82-118 0-183 61t-66 167q0 110 84 170t257 61h102v51q0 127-116 127-65 0-101-25t-37-74l-173 14q0 104 87 168t224 65q135 0 213-72t78-205V883q0-97 26-178H604zM429 835q40 0 82 18t69 44v136H474q-76-1-119-31t-43-79q0-88 117-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAB",
    horizAdvX: 1023,
    d: "M559 524l240-399H613L333 515v19l280 390h186L559 524zm129 0l240-399H742L462 515v19l280 390h186L688 524z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAC",
    horizAdvX: 1129,
    d: "M961 374H761v260H126v171h835V374z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAD",
    horizAdvX: 794,
    d: "M673 507H110v233h563V507z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAE",
    horizAdvX: 1606,
    d: "M86 729q0 202 93 375t259 272 358 100 357-99 259-273 94-375q0-204-95-377T1152 79 796-20Q603-20 439 80T180 353 86 729zm1297 0q0 166-75 308t-212 228-300 86q-159 0-295-82t-215-226-78-314 77-314 214-227 297-84 297 85 214 229 76 311zm-731-76V316H501v850h281q151 0 238-68t87-195q0-112-113-174 61-31 85-86t25-138 3-116 14-57v-16H966q-13 34-13 194 0 76-33 109t-110 34H652zm0 134h136q74 0 121 32t48 84q0 70-35 99t-129 31H652V787z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xAF",
    horizAdvX: 1026,
    d: "M858 1287H168v167h690v-167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB0",
    horizAdvX: 795,
    d: "M126 1200q0 114 81 195t191 81q109 0 188-80t80-196-79-193-189-79q-108 0-190 78t-82 194zm272-124q53 0 87 35t35 89q0 52-34 90t-88 38-89-38-36-90 36-88 89-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB1",
    horizAdvX: 1100,
    d: "M677 942h328V701H677V337H424v364H89v241h335v343h253V942zM977 1H113v235h864V1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB2",
    horizAdvX: 763,
    d: "M693 667H73v138l287 257q56 49 80 91t25 65q0 84-95 84-50 0-79-31t-30-78H55q0 116 85 195t221 79q148 0 228-64t81-184q0-70-36-128T490 946L342 831h351V667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB3",
    horizAdvX: 763,
    d: "M273 1137h82q119 0 119 88 0 35-28 56t-78 21q-42 0-71-15t-30-45H62q0 102 84 163t216 62q145 0 230-59t86-167q0-119-135-169 150-41 150-184 0-105-91-168t-240-64q-142 0-228 66T48 903h206q0-34 34-58t86-25q60 0 86 26t27 62q0 92-122 93h-92v136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB4",
    horizAdvX: 679,
    d: "M298 1536h315l-277-310H101l197 310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB5",
    horizAdvX: 1261,
    d: "M428 1082V459q0-126 40-185t140-60q149 0 205 105v763h289V0H833l-6 68q-89-89-225-89-102 0-174 45v-440H139v1498h289z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB6",
    horizAdvX: 1003,
    d: "M650 0v520h-80q-230 0-362 127T75 988q0 213 133 340t363 128h298V0H650z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB7",
    horizAdvX: 617,
    d: "M140 697q0 69 46 112t117 43 117-43 47-112-47-111-117-43q-72 0-117 43t-46 111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB8",
    horizAdvX: 548,
    d: "M345 7l-11-58q150-27 150-173 0-110-91-174t-258-64l-7 167q112 0 112 81 0 42-33 57T98-136L129 7h216z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xB9",
    horizAdvX: 763,
    d: "M528 667H324v548l-189-41v158l374 121h19V667z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBA",
    horizAdvX: 936,
    d: "M118 1121q0 160 95 257t251 98 251-97 96-263v-72q0-159-94-256t-251-98q-158 0-253 98t-95 261v72zm175-77q0-98 46-153t127-55q78 0 123 54t47 151v80q0 97-46 152t-126 55q-78 0-124-54t-47-157v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBB",
    horizAdvX: 1023,
    d: "M272 923l280-390v-19L272 124H85l240 399L85 923h187zm393 0l280-390v-19L665 124H478l240 399-240 400h187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBC",
    horizAdvX: 1470,
    d: "M494 664H290v548l-189-41v158l374 121h19V664zm-36-547l-141 76 711 1138 141-76L458 117zm844 209h88V159h-88V0h-205v159H751l-12 135 357 495h206V326zm-367 0h162v212l-14-22-148-190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBD",
    horizAdvX: 1559,
    d: "M416 117l-141 76 711 1138 141-76L416 117zm61 553H273v548l-189-41v158l374 121h19V670zM1477 0H857v138l287 257q56 49 80 91t25 65q0 84-95 84-50 0-79-31t-30-78H839q0 116 85 195t221 79q148 0 228-64t81-184q0-70-36-128t-144-145l-148-115h351V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBE",
    horizAdvX: 1655,
    d: "M619 117l-141 76 711 1138 141-76L619 117zm841 209h88V159h-88V0h-205v159H909l-12 135 357 495h206V326zm-367 0h162v212l-14-22-148-190zm-774 811h82q119 0 119 88 0 35-28 56t-78 21q-42 0-71-15t-30-45H108q0 102 84 163t216 62q145 0 230-59t86-167q0-119-135-169 150-41 150-184 0-105-91-168t-240-64q-142 0-228 66T94 903h206q0-34 34-58t86-25q60 0 86 26t27 62q0 92-122 93h-92v136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xBF",
    horizAdvX: 1019,
    d: "M666 643q0-133-31-215T525 272 417 162t-43-73-15-81q0-157 154-157 77 0 122 45t48 126h289q-2-192-123-299T518-385q-213 0-331 101T69 6q0 159 153 312l97 93q50 45 69 94t22 138h256zm36 306q0-67-46-110t-116-43-116 43-46 110 44 110 118 43 117-43 45-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC0",
    horizAdvX: 1378,
    d: "M952 300H426L326 0H7l542 1456h278L1372 0h-319L952 300zM507 543h364l-183 545-181-545zm329 993H599l-276 310h315l198-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC1",
    horizAdvX: 1378,
    d: "M952 300H426L326 0H7l542 1456h278L1372 0h-319L952 300zM507 543h364l-183 545-181-545zm243 1303h315l-277-310H553l197 310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC2",
    horizAdvX: 1378,
    d: "M952 300H426L326 0H7l542 1456h278L1372 0h-319L952 300zM507 543h364l-183 545-181-545zm569 1023v-12H846l-154 145-154-145H312v16l296 276h168l300-280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC3",
    horizAdvX: 1378,
    d: "M952 300H426L326 0H7l542 1456h278L1372 0h-319L952 300zM507 543h364l-183 545-181-545zm561 1289q0-113-66-189t-161-77q-38 0-67 8t-82 37-75 34-50 7q-35 0-59-25t-25-71l-168 10q0 111 65 189t161 78q30 0 56-7t87-37 83-35 48-6q35 0 60 24t26 71l167-11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC4",
    horizAdvX: 1378,
    d: "M952 300H426L326 0H7l542 1456h278L1372 0h-319L952 300zM507 543h364l-183 545-181-545zm80 1132q0-53-39-89t-100-37q-62 0-100 37t-38 89 38 89 100 38 100-37 39-90zm210 0q0 54 40 90t99 37q59 0 98-37t40-90q0-52-38-89t-100-38-100 37-39 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC5",
    horizAdvX: 1378,
    d: "M952 300H426L326 0H7l542 1456h278L1372 0h-319L952 300zM507 543h364l-183 545-181-545zm-37 1187q0 86 65 145t158 60q92 0 157-58t66-147q0-85-64-143t-159-58q-97 0-160 59t-63 142zm115 0q0-44 29-75t79-32 79 31 29 76q0 46-29 77t-79 32-78-31-30-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC6",
    horizAdvX: 1925,
    d: "M1865 0H968l-14 333H508L341 0H2l786 1456h1016v-236h-598l15-355h502V629h-492l16-394h618V0zM633 580h311l-24 570-287-570z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC7",
    horizAdvX: 1340,
    d: "M1273 485q-17-235-173-370T687-20q-280 0-440 188T86 686v89q0 210 74 370t211 245 320 86q252 0 406-135t178-379H975q-11 141-78 204t-206 64q-150 0-224-107t-77-334V679q0-236 71-345t226-109q139 0 207 63t79 197h300zM797 6l-11-58q150-27 150-173 0-110-91-174t-258-64l-7 167q112 0 112 81 0 42-33 57t-109 21L581 6h216z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC8",
    horizAdvX: 1152,
    d: "M1006 631H430V241h676V0H130v1456h974v-243H430V866h576V631zm-227 908H542l-276 310h315l198-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xC9",
    horizAdvX: 1152,
    d: "M1006 631H430V241h676V0H130v1456h974v-243H430V866h576V631zM693 1849h315l-277-310H496l197 310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCA",
    horizAdvX: 1152,
    d: "M1006 631H430V241h676V0H130v1456h974v-243H430V866h576V631zm13 938v-12H789l-154 145-154-145H255v16l296 276h168l300-280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCB",
    horizAdvX: 1152,
    d: "M1006 631H430V241h676V0H130v1456h974v-243H430V866h576V631zM530 1678q0-53-39-89t-100-37q-62 0-100 37t-38 89 38 89 100 38 100-37 39-90zm210 0q0 54 40 90t99 37q59 0 98-37t40-90q0-52-38-89t-100-38-100 37-39 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCC",
    horizAdvX: 597,
    d: "M449 0H149v1456h300V0zm-6 1539H206l-276 310h315l198-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCD",
    horizAdvX: 597,
    d: "M449 0H149v1456h300V0zm-93 1849h315l-277-310H159l197 310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCE",
    horizAdvX: 597,
    d: "M449 0H149v1456h300V0zm234 1569v-12H453l-154 145-154-145H-81v16l296 276h168l300-280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xCF",
    horizAdvX: 597,
    d: "M449 0H149v1456h300V0zM194 1678q0-53-39-89t-100-37q-62 0-100 37t-38 89 38 89 100 38 100-37 39-90zm210 0q0 54 40 90t99 37q59 0 98-37t40-90q0-52-38-89t-100-38-100 37-39 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD0",
    horizAdvX: 1361,
    d: "M160 0v642H-20v183h180v631h448q192 0 343-86t237-246 85-363v-67q0-203-83-361T954 88 611 0H160zm519 642H460V241h145q178 0 271 117t93 336v68q0 222-92 336t-269 115H460V825h219V642z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD1",
    horizAdvX: 1446,
    d: "M1314 0h-300L430 958V0H130v1456h300l585-960v960h299V0zm-212 1832q0-113-66-189t-161-77q-38 0-67 8t-82 37-75 34-50 7q-35 0-59-25t-25-71l-168 10q0 111 65 189t161 78q30 0 56-7t87-37 83-35 48-6q35 0 60 24t26 71l167-11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD2",
    horizAdvX: 1414,
    d: "M1326 695q0-215-76-377T1033 68 708-20q-181 0-323 87T165 315 86 687v72q0 215 77 378t219 251 324 88 323-87 219-251 78-378v-65zm-304 66q0 229-82 348t-234 119q-151 0-233-117t-83-345v-71q0-223 82-346t236-123q151 0 232 118t82 346v71zm-172 775H613l-276 310h315l198-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD3",
    horizAdvX: 1414,
    d: "M1326 695q0-215-76-377T1033 68 708-20q-181 0-323 87T165 315 86 687v72q0 215 77 378t219 251 324 88 323-87 219-251 78-378v-65zm-304 66q0 229-82 348t-234 119q-151 0-233-117t-83-345v-71q0-223 82-346t236-123q151 0 232 118t82 346v71zM764 1846h315l-277-310H567l197 310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD4",
    horizAdvX: 1414,
    d: "M1326 695q0-215-76-377T1033 68 708-20q-181 0-323 87T165 315 86 687v72q0 215 77 378t219 251 324 88 323-87 219-251 78-378v-65zm-304 66q0 229-82 348t-234 119q-151 0-233-117t-83-345v-71q0-223 82-346t236-123q151 0 232 118t82 346v71zm68 805v-12H860l-154 145-154-145H326v16l296 276h168l300-280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD5",
    horizAdvX: 1414,
    d: "M1326 695q0-215-76-377T1033 68 708-20q-181 0-323 87T165 315 86 687v72q0 215 77 378t219 251 324 88 323-87 219-251 78-378v-65zm-304 66q0 229-82 348t-234 119q-151 0-233-117t-83-345v-71q0-223 82-346t236-123q151 0 232 118t82 346v71zm60 1071q0-113-66-189t-161-77q-38 0-67 8t-82 37-75 34-50 7q-35 0-59-25t-25-71l-168 10q0 111 65 189t161 78q30 0 56-7t87-37 83-35 48-6q35 0 60 24t26 71l167-11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD6",
    horizAdvX: 1414,
    d: "M1326 695q0-215-76-377T1033 68 708-20q-181 0-323 87T165 315 86 687v72q0 215 77 378t219 251 324 88 323-87 219-251 78-378v-65zm-304 66q0 229-82 348t-234 119q-151 0-233-117t-83-345v-71q0-223 82-346t236-123q151 0 232 118t82 346v71zm-421 914q0-53-39-89t-100-37q-62 0-100 37t-38 89 38 89 100 38 100-37 39-90zm210 0q0 54 40 90t99 37q59 0 98-37t40-90q0-52-38-89t-100-38-100 37-39 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD7",
    horizAdvX: 1088,
    d: "M65 373l307 313L65 999l170 168 304-311 305 311 170-168-307-313 307-313-170-168-305 310-304-310L65 373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD8",
    horizAdvX: 1411,
    d: "M1333 695q0-215-76-377T1040 68 715-20q-164 0-295 70L335-95H147l143 242Q93 342 93 702v57q0 215 77 378t219 251 324 88q175 0 314-82l74 124h187l-134-227q179-198 179-537v-59zm-936 0q0-172 49-285l447 757q-73 61-180 61-151 0-233-117t-83-345v-71zm633 66q0 151-38 256L552 273q70-47 163-47 151 0 232 118t83 346v71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xD9",
    horizAdvX: 1348,
    d: "M1232 1456V497q0-239-149-378T674-20q-255 0-405 135T116 486v970h300V495q0-143 68-208t190-66q253 0 257 266v969h301zm-418 80H577l-276 310h315l198-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDA",
    horizAdvX: 1348,
    d: "M1232 1456V497q0-239-149-378T674-20q-255 0-405 135T116 486v970h300V495q0-143 68-208t190-66q253 0 257 266v969h301zm-504 390h315l-277-310H531l197 310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDB",
    horizAdvX: 1348,
    d: "M1232 1456V497q0-239-149-378T674-20q-255 0-405 135T116 486v970h300V495q0-143 68-208t190-66q253 0 257 266v969h301zm-178 110v-12H824l-154 145-154-145H290v16l296 276h168l300-280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDC",
    horizAdvX: 1348,
    d: "M1232 1456V497q0-239-149-378T674-20q-255 0-405 135T116 486v970h300V495q0-143 68-208t190-66q253 0 257 266v969h301zm-667 219q0-53-39-89t-100-37q-62 0-100 37t-38 89 38 89 100 38 100-37 39-90zm210 0q0 54 40 90t99 37q59 0 98-37t40-90q0-52-38-89t-100-38-100 37-39 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDD",
    horizAdvX: 1266,
    d: "M632 800l303 656h328L785 528V0H480v528L2 1456h329l301-656zm61 1046h315l-277-310H496l197 310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDE",
    horizAdvX: 1246,
    d: "M422 1456v-267h230q162-1 281-56t184-158 64-237q0-202-138-324T664 287H422V0H133v1456h289zm0-500V520h223q117 0 182 59t65 157-63 158-176 62H422z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xDF",
    horizAdvX: 1292,
    d: "M424 0H135v1101q0 220 124 339t350 119q191 0 306-99t116-271q0-108-53-195t-54-164q0-37 30-76t119-118q151-134 151-282 0-177-115-275T779-20q-81 0-160 16T500 36l54 229q98-52 219-52 79 0 121 36t42 100q0 46-34 89T785 548Q635 668 635 818q0 96 55 186t55 170q0 70-44 111t-113 42q-159 0-164-213V0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE0",
    horizAdvX: 1098,
    d: "M738 0q-20 39-29 97Q604-20 436-20q-159 0-263 92T68 304q0 172 127 264t369 93h133v62q0 75-38 120t-122 45q-73 0-114-35t-42-96H92q0 94 58 174t164 125 238 46q200 0 317-100t118-283V250q1-154 43-233V0H738zM499 201q64 0 118 28t80 77v186H589q-217 0-231-150l-1-17q0-54 38-89t104-35zm196 1025H458l-276 310h315l198-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE1",
    horizAdvX: 1098,
    d: "M738 0q-20 39-29 97Q604-20 436-20q-159 0-263 92T68 304q0 172 127 264t369 93h133v62q0 75-38 120t-122 45q-73 0-114-35t-42-96H92q0 94 58 174t164 125 238 46q200 0 317-100t118-283V250q1-154 43-233V0H738zM499 201q64 0 118 28t80 77v186H589q-217 0-231-150l-1-17q0-54 38-89t104-35zm110 1335h315l-277-310H412l197 310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE2",
    horizAdvX: 1098,
    d: "M738 0q-20 39-29 97Q604-20 436-20q-159 0-263 92T68 304q0 172 127 264t369 93h133v62q0 75-38 120t-122 45q-73 0-114-35t-42-96H92q0 94 58 174t164 125 238 46q200 0 317-100t118-283V250q1-154 43-233V0H738zM499 201q64 0 118 28t80 77v186H589q-217 0-231-150l-1-17q0-54 38-89t104-35zm436 1055v-12H705l-154 145-154-145H171v16l296 276h168l300-280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE3",
    horizAdvX: 1098,
    d: "M738 0q-20 39-29 97Q604-20 436-20q-159 0-263 92T68 304q0 172 127 264t369 93h133v62q0 75-38 120t-122 45q-73 0-114-35t-42-96H92q0 94 58 174t164 125 238 46q200 0 317-100t118-283V250q1-154 43-233V0H738zM499 201q64 0 118 28t80 77v186H589q-217 0-231-150l-1-17q0-54 38-89t104-35zm428 1578q0-113-66-189t-161-77q-38 0-67 8t-82 37-75 34-50 7q-35 0-59-25t-25-71l-168 10q0 111 65 189t161 78q30 0 56-7t87-37 83-35 48-6q35 0 60 24t26 71l167-11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE4",
    horizAdvX: 1098,
    d: "M738 0q-20 39-29 97Q604-20 436-20q-159 0-263 92T68 304q0 172 127 264t369 93h133v62q0 75-38 120t-122 45q-73 0-114-35t-42-96H92q0 94 58 174t164 125 238 46q200 0 317-100t118-283V250q1-154 43-233V0H738zM499 201q64 0 118 28t80 77v186H589q-217 0-231-150l-1-17q0-54 38-89t104-35zm-53 1164q0-53-39-89t-100-37q-62 0-100 37t-38 89 38 89 100 38 100-37 39-90zm210 0q0 54 40 90t99 37q59 0 98-37t40-90q0-52-38-89t-100-38-100 37-39 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE5",
    horizAdvX: 1098,
    d: "M738 0q-20 39-29 97Q604-20 436-20q-159 0-263 92T68 304q0 172 127 264t369 93h133v62q0 75-38 120t-122 45q-73 0-114-35t-42-96H92q0 94 58 174t164 125 238 46q200 0 317-100t118-283V250q1-154 43-233V0H738zM499 201q64 0 118 28t80 77v186H589q-217 0-231-150l-1-17q0-54 38-89t104-35zM329 1420q0 86 65 145t158 60q92 0 157-58t66-147q0-85-64-143t-159-58q-97 0-160 59t-63 142zm115 0q0-44 29-75t79-32 79 31 29 76q0 46-29 77t-79 32-78-31-30-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE6",
    horizAdvX: 1729,
    d: "M1246-20q-247 0-386 147-64-69-166-108T466-20q-186 0-293 89T66 319q0 157 124 243t367 87h168v57q0 76-40 119t-118 43q-82 0-129-35t-48-88l-289 19q0 149 130 243t339 95q211 0 327-110 126 112 326 110 212 0 333-131t121-364V450h-668q11-116 80-177t187-61q77 0 142 16t153 61l77-189q-73-56-180-88t-222-32zM521 192q49 0 107 22t97 58v189H561q-95-1-150-43t-56-103q0-56 40-89t126-34zm702 676q-90 0-144-57t-68-167h382v28q0 94-43 145t-127 51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE7",
    horizAdvX: 1068,
    d: "M561 213q80 0 130 44t52 117h271q-1-110-60-201T793 31 566-20q-232 0-366 147T66 535v19q0 250 133 399t365 149q203 0 325-115t125-308H743q-2 84-52 136t-132 53q-101 0-152-73t-52-239v-30q0-167 51-240t155-73zM666 6l-11-58q150-27 150-173 0-110-91-174t-258-64l-7 167q112 0 112 81 0 42-33 57t-109 21L450 6h216z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE8",
    horizAdvX: 1107,
    d: "M609-20q-238 0-387 146T72 515v28q0 163 63 291t178 198 264 70q222 0 349-140t128-397V447H365q14-106 84-170t179-64q167 0 261 121l142-159Q966 83 855 32T609-20zm-33 888q-86 0-139-58t-69-166h402v23q-2 96-52 148t-142 53zm112 358H451l-276 310h315l198-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xE9",
    horizAdvX: 1107,
    d: "M609-20q-238 0-387 146T72 515v28q0 163 63 291t178 198 264 70q222 0 349-140t128-397V447H365q14-106 84-170t179-64q167 0 261 121l142-159Q966 83 855 32T609-20zm-33 888q-86 0-139-58t-69-166h402v23q-2 96-52 148t-142 53zm26 668h315l-277-310H405l197 310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xEA",
    horizAdvX: 1107,
    d: "M609-20q-238 0-387 146T72 515v28q0 163 63 291t178 198 264 70q222 0 349-140t128-397V447H365q14-106 84-170t179-64q167 0 261 121l142-159Q966 83 855 32T609-20zm-33 888q-86 0-139-58t-69-166h402v23q-2 96-52 148t-142 53zm352 388v-12H698l-154 145-154-145H164v16l296 276h168l300-280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xEB",
    horizAdvX: 1107,
    d: "M609-20q-238 0-387 146T72 515v28q0 163 63 291t178 198 264 70q222 0 349-140t128-397V447H365q14-106 84-170t179-64q167 0 261 121l142-159Q966 83 855 32T609-20zm-33 888q-86 0-139-58t-69-166h402v23q-2 96-52 148t-142 53zm-137 497q0-53-39-89t-100-37q-62 0-100 37t-38 89 38 89 100 38 100-37 39-90zm210 0q0 54 40 90t99 37q59 0 98-37t40-90q0-52-38-89t-100-38-100 37-39 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xEC",
    horizAdvX: 561,
    d: "M423 0H134v1082h289V0zm2 1211H188l-276 310h315l198-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xED",
    horizAdvX: 561,
    d: "M423 0H134v1082h289V0zm-85 1777h315l-277-310H141l197 310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xEE",
    horizAdvX: 561,
    d: "M423 0H134v1082h289V0zm242 1241v-12H435l-154 145-154-145H-99v16l296 276h168l300-280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xEF",
    horizAdvX: 561,
    d: "M423 0H134v1082h289V0zM176 1350q0-53-39-89t-100-37q-62 0-100 37t-38 89 38 89 100 38 100-37 39-90zm210 0q0 54 40 90t99 37q59 0 98-37t40-90q0-52-38-89t-100-38-100 37-39 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF0",
    horizAdvX: 1178,
    d: "M849 1305q255-262 256-654v-74q0-172-66-309T853 56 587-20q-144 0-259 63T149 219 84 468q0 231 123 364t329 134q136 0 244-76-49 152-166 265l-191-122-78 114 152 97q-116 72-264 111l91 224q238-48 416-180l171 109 77-114-139-89zm-33-642q-68 83-215 83-113 0-170-74t-58-204q0-112 60-183t158-72q103 0 164 90t61 249v111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF1",
    horizAdvX: 1147,
    d: "M377 1082l9-125q116 145 311 145 172 0 256-101t86-302V0H750v692q0 92-40 133t-133 42q-122 0-183-104V0H105v1082h272zm574 697q0-113-66-189t-161-77q-38 0-67 8t-82 37-75 34-50 7q-35 0-59-25t-25-71l-168 10q0 111 65 189t161 78q30 0 56-7t87-37 83-35 48-6q35 0 60 24t26 71l167-11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF2",
    horizAdvX: 1158,
    d: "M66 551q0 161 62 287t178 195 271 69q219 0 357-134t155-364l2-74q0-249-139-399T579-20 206 130 66 538v13zm289-21q0-154 58-235t166-82q105 0 164 80t59 258q0 151-59 234t-166 83q-106 0-164-82t-58-256zm365 696H483l-276 310h315l198-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF3",
    horizAdvX: 1158,
    d: "M66 551q0 161 62 287t178 195 271 69q219 0 357-134t155-364l2-74q0-249-139-399T579-20 206 130 66 538v13zm289-21q0-154 58-235t166-82q105 0 164 80t59 258q0 151-59 234t-166 83q-106 0-164-82t-58-256zm279 1006h315l-277-310H437l197 310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF4",
    horizAdvX: 1158,
    d: "M66 551q0 161 62 287t178 195 271 69q219 0 357-134t155-364l2-74q0-249-139-399T579-20 206 130 66 538v13zm289-21q0-154 58-235t166-82q105 0 164 80t59 258q0 151-59 234t-166 83q-106 0-164-82t-58-256zm605 726v-12H730l-154 145-154-145H196v16l296 276h168l300-280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF5",
    horizAdvX: 1158,
    d: "M66 551q0 161 62 287t178 195 271 69q219 0 357-134t155-364l2-74q0-249-139-399T579-20 206 130 66 538v13zm289-21q0-154 58-235t166-82q105 0 164 80t59 258q0 151-59 234t-166 83q-106 0-164-82t-58-256zm597 1249q0-113-66-189t-161-77q-38 0-67 8t-82 37-75 34-50 7q-35 0-59-25t-25-71l-168 10q0 111 65 189t161 78q30 0 56-7t87-37 83-35 48-6q35 0 60 24t26 71l167-11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF6",
    horizAdvX: 1158,
    d: "M66 551q0 161 62 287t178 195 271 69q219 0 357-134t155-364l2-74q0-249-139-399T579-20 206 130 66 538v13zm289-21q0-154 58-235t166-82q105 0 164 80t59 258q0 151-59 234t-166 83q-106 0-164-82t-58-256zm116 835q0-53-39-89t-100-37q-62 0-100 37t-38 89 38 89 100 38 100-37 39-90zm210 0q0 54 40 90t99 37q59 0 98-37t40-90q0-52-38-89t-100-38-100 37-39 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF7",
    horizAdvX: 1168,
    d: "M1091 571H63v230h1028V571zm-676 518q0 68 45 110t118 42q71 0 117-41t47-111q0-67-45-108t-119-42q-75 0-119 42t-44 108zm0-812q0 68 45 110t118 42q71 0 117-41t47-111q0-67-45-108t-119-42q-75 0-119 42t-44 108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF8",
    horizAdvX: 1156,
    d: "M66 551q0 161 62 287t178 195 271 69q101 0 186-29l70 143h161l-103-211q200-149 200-475 0-249-139-399T579-20q-95 0-176 26l-72-148H170L273 70Q66 216 66 551zm289-21q0-130 41-208l260 532q-36 14-79 14-106 0-164-82t-58-256zm447 21q0 114-37 196L509 223q30-10 70-10 105 0 164 80t59 258z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xF9",
    horizAdvX: 1146,
    d: "M759 110Q652-20 463-20 289-20 198 80t-94 293v709h289V383q0-169 154-169 147 0 202 102v766h290V0H767l-8 110zm-43 1116H479l-276 310h315l198-310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFA",
    horizAdvX: 1146,
    d: "M759 110Q652-20 463-20 289-20 198 80t-94 293v709h289V383q0-169 154-169 147 0 202 102v766h290V0H767l-8 110zM630 1536h315l-277-310H433l197 310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFB",
    horizAdvX: 1146,
    d: "M759 110Q652-20 463-20 289-20 198 80t-94 293v709h289V383q0-169 154-169 147 0 202 102v766h290V0H767l-8 110zm197 1146v-12H726l-154 145-154-145H192v16l296 276h168l300-280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFC",
    horizAdvX: 1146,
    d: "M759 110Q652-20 463-20 289-20 198 80t-94 293v709h289V383q0-169 154-169 147 0 202 102v766h290V0H767l-8 110zM467 1365q0-53-39-89t-100-37q-62 0-100 37t-38 89 38 89 100 38 100-37 39-90zm210 0q0 54 40 90t99 37q59 0 98-37t40-90q0-52-38-89t-100-38-100 37-39 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFD",
    horizAdvX: 1028,
    d: "M515 409l200 673h310L590-168l-24-57q-97-212-320-212-63 0-128 19v219l44-1q82 0 122 25t64 83l34 89L3 1082h311l201-673zm63 1127h315l-277-310H381l197 310z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFE",
    horizAdvX: 1162,
    d: "M1087 531q0-250-113-400T667-20Q503-20 403 93v-509H113v1952h290V989q100 113 262 113 198 0 310-147t112-410v-14zm-289 21q0 151-53 233t-156 82q-132 0-186-102V318q54-105 188-105 207 0 207 339z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\xFF",
    horizAdvX: 1028,
    d: "M515 409l200 673h310L590-168l-24-57q-97-212-320-212-63 0-128 19v219l44-1q82 0 122 25t64 83l34 89L3 1082h311l201-673zm-100 956q0-53-39-89t-100-37q-62 0-100 37t-38 89 38 89 100 38 100-37 39-90zm210 0q0 54 40 90t99 37q59 0 98-37t40-90q0-52-38-89t-100-38-100 37-39 90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2013",
    horizAdvX: 1294,
    d: "M1444 596H408v236h1036V596z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2014",
    horizAdvX: 1563,
    d: "M1746 596H365v236h1381V596z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2018",
    horizAdvX: 479,
    d: "M286 1570l136-79q-86-136-89-276v-167H104v150q0 94 52 200t130 172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2019",
    horizAdvX: 470,
    d: "M194 1009l-136 79q86 135 89 279v169h230v-155q0-90-50-195t-133-177z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u201A",
    horizAdvX: 508,
    d: "M202-305L66-226q78 126 81 274v181h238l-1-166q-1-89-50-192T202-305z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u201C",
    horizAdvX: 831,
    d: "M294 1570l136-79q-86-136-89-276v-167H112v150q0 94 52 200t130 172zm343 0l136-79q-86-136-89-276v-167H455v150q0 94 52 200t130 172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u201D",
    horizAdvX: 837,
    d: "M208 1009l-136 79q86 135 89 279v169h230v-155q0-90-50-195t-133-177zm347 0l-136 79q86 135 89 279v169h230v-155q0-90-50-195t-133-177z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u201E",
    horizAdvX: 825,
    d: "M209-325L66-246q78 134 81 293v216h238l-1-199q-1-97-48-206T209-325zm336 0l-143 79q86 148 89 294v215h238l-1-203q-2-96-52-205T545-325z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2022",
    horizAdvX: 736,
    d: "M135 766q0 104 66 167t170 63q108 0 172-62t67-163v-43q0-103-65-165t-172-63q-105 0-171 62t-67 169v35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u2039",
    horizAdvX: 638,
    d: "M334 524l240-399H388L108 515v19l280 390h186L334 524z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\u203A",
    horizAdvX: 618,
    d: "M267 923l280-390v-19L267 124H80l240 399L80 923h187z"
  })))));
}
export default SvgRobotoV29Latin700;